/**
 * Returns users whose birthday (month + day) matches today's date.
 */
class GetBirthdayUsersUseCase {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }

    async execute() {
        const allUsers = await this.userRepository.getUsers();
        const today = new Date();
        return allUsers.filter(user => {
            if (!user.dob) return false;
            const dob = user.dob instanceof Date ? user.dob : new Date(user.dob);
            return dob.getMonth() === today.getMonth() && dob.getDate() === today.getDate();
        });
    }
}

export default GetBirthdayUsersUseCase;
